import makeStyles from "@material-ui/core/styles/makeStyles";
import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    display: "block",
    width: 12,
    height: 12,
    borderRadius: "50%"
  },
  [racehorse360.HealthWatchStatus.HEALTH_WATCH_STATUS_INVALID]: {
    display: "none"
  },
  [racehorse360.HealthWatchStatus.HEALTH_WATCH_STATUS_GREEN]: {
    backgroundColor: theme.palette.common.white,
    border: "1px solid rgba(51, 51, 51, 1)"
  },
  [racehorse360.HealthWatchStatus.HEALTH_WATCH_STATUS_YELLOW]: {
    backgroundColor: "#ffe08f",
    border: "1px solid #322c1b"
  },
  [racehorse360.HealthWatchStatus.HEALTH_WATCH_STATUS_RED]: {
    backgroundColor: "#ff4b4f",
    border: "1px solid #411313"
  }
}));
